function assetValues<T extends Record<string, string>>(assets: T) {
    return Object.values(assets) as Array<T[keyof T]>
}

export const gltfAsset = {
    StartArea: '/prototype/StartArea.glb',
    EndArea: '/prototype/EndArea.glb',
    Finishline: '/prototype/Finishline.glb',
    Powerup: '/prototype/Powerup.glb',
    Card: '/prototype/card.glb',
    Chameleon_01: '/prototype/Chameleon_01.glb',
    Track: '/prototype/Track.glb',
    Border_LVL_01: '/prototype/Border_lvl01.glb',
    Border_LVL_02: '/prototype/Border_lvl02.glb',
    Border_LVL_03: '/prototype/Border_lvl03.glb',
    Border_LVL_04: '/prototype/Border_lvl04.glb',
    Tunnel_Inside: '/prototype/tunnel_inside.glb',
    Tunnel_Start: '/prototype/tunnel_start.glb',
    Tunnel_Exit: '/prototype/tunnel_exit.glb',
    Cloud: '/prototype/Cloud.glb',
    Lvl04Bridge: '/prototype/Lvl_04_Bridge.glb',
    Lvl04PirsmA: '/prototype/LVL04_PirsmA.glb',
    Lvl04PirsmB: '/prototype/LVL04_PirsmB.glb',
    Lvl04SpaceDonut: '/prototype/LVL04_SpaceDonut.glb',
    Lvl04SpaceHeart: '/prototype/LVL04_SpaceHeart.glb',
    Lvl04StarA: '/prototype/LVL04_StarA.glb',
    Lvl04StarB: '/prototype/LVL04_StarB.glb',
    LVL2_Clock: '/prototype/LVL2_Clock.glb',
    LVL2_Geometries: '/prototype/LVL2_Geometries.glb',
    LVL2_Globe: '/prototype/LVL2_Globe.glb',
    LVL2_MathScience: '/prototype/LVL2_MathScience.glb',
    LVL3_Folder: '/prototype/LVL3_Folder.glb',
    LVL3_Paperplane: '/prototype/LVL3_Paperplane.glb',
    LVL3_Window1: '/prototype/LVL3_Window1.glb',
    LVL3_Window2: '/prototype/LVL3_Window2.glb',
    Rainbow: '/prototype/Rainbow.glb',
    Teddy: '/prototype/Teddy.glb',
    ToyCar: '/prototype/ToyCar.glb',
    Platform_LVL_01: '/prototype/Platform_LVL_01.glb',
    Platform_LVL_02: '/prototype/Platform_LVL_02.glb',
    Platform_LVL_03: '/prototype/Platform_LVL_03.glb',
    Platform_LVL_04: '/prototype/Platform_LVL_04.glb',
    PlatformContent_LVL01_A: '/prototype/platformContent_lvl01_a.glb',
    PlatformContent_LVL01_B: '/prototype/platformContent_lvl01_b.glb',
    PlatformContent_LVL01_C: '/prototype/platformContent_lvl01_c.glb',
    PlatformContent_LVL02_A: '/prototype/platformContent_lvl02_a.glb',
    PlatformContent_LVL02_B: '/prototype/platformContent_lvl02_b.glb',
    PlatformContent_LVL02_C: '/prototype/platformContent_lvl02_c.glb',
    PlatformContent_LVL03_A: '/prototype/platformContent_lvl03_a.glb',
    PlatformContent_LVL03_B: '/prototype/platformContent_lvl03_b.glb',
    PlatformContent_LVL03_C: '/prototype/platformContent_lvl03_c.glb',
    PlatformContent_LVL04_A: '/prototype/platformContent_lvl04_a.glb',
    PlatformContent_LVL04_B: '/prototype/platformContent_lvl04_b.glb',
    PlatformContent_LVL04_C: '/prototype/platformContent_lvl04_c.glb',
    Obstacle_LVL01_TYP01: '/prototype/obstacle_lvl01_typ01.glb',
    Obstacle_LVL01_TYP02: '/prototype/obstacle_lvl01_typ02.glb',
    Obstacle_LVL01_TYP03: '/prototype/obstacle_lvl01_typ03.glb',
    Obstacle_LVL01_TYP06: '/prototype/obstacle_lvl01_typ06.glb',
    Obstacle_LVL02_TYP01: '/prototype/obstacle_lvl02_typ01.glb',
    Obstacle_LVL02_TYP02: '/prototype/obstacle_lvl02_typ02.glb',
    Obstacle_LVL02_TYP04: '/prototype/obstacle_lvl02_typ04.glb',
    Obstacle_LVL02_TYP05: '/prototype/obstacle_lvl02_typ05.glb',
    Obstacle_LVL03_TYP01: '/prototype/obstacle_lvl03_typ01.glb',
    Obstacle_LVL03_TYP04: '/prototype/obstacle_lvl03_typ04.glb',
    Obstacle_LVL03_TYP05: '/prototype/obstacle_lvl03_typ05.glb',
    Obstacle_LVL03_TYP06: '/prototype/obstacle_lvl03_typ06.glb',
    Obstacle_LVL04_TYP03: '/prototype/obstacle_lvl04_typ03.glb',
    Obstacle_LVL04_TYP05: '/prototype/obstacle_lvl04_typ05.glb',
    Obstacle_LVL04_TYP06: '/prototype/obstacle_lvl04_typ06.glb',
    Obstacle_LVL04_TYP07: '/prototype/obstacle_lvl04_typ07.glb',
    Heart: '/prototype/Heart.glb',
    Coin: '/prototype/Coin.glb',
} as const

export const textureAsset = {
    Atlas: '/textures/general/T_Atlas.png',

    Orb_Matcap: '/textures/Orb_matcap.png',
    PowerUps_Atlas: '/textures/PowerUps.png',
    EffectRunFootsteps: '/textures/footsteps/Footprint.png',
    EffectRunDust: '/textures/footsteps/Dust.png',
    EffectRunLeaves: '/textures/footsteps/Leaves.png',

    EndCardNameStarChaser: '/textures/endcard/Card_Name_StarChaser.png',
    EndCardNameRushGuard: '/textures/endcard/Card_Name_RushGuard.png',
    EndCardNamePowerCharger: '/textures/endcard/Card_Name_PowerCharger.png',
    EndCardNameTreasureHunter: '/textures/endcard/Card_Name_TreasureHunter.png',
    EndCardPowerUpBattery: '/textures/endcard/Card_PowerUP_Battery.png',
    EndCardPowerUpCoin: '/textures/endcard/Card_PowerUP_Coin.png',
    EndCardPowerUpShield: '/textures/endcard/Card_PowerUP_Shield.png',
    EndCardPowerUpStar: '/textures/endcard/Card_PowerUP_Star.png',
    EndCardCollectableHeart: '/textures/endcard/Card_Collectable_Heart.png',
    EndCardCollectableCoin: '/textures/endcard/Card_Collectable_Coin.png',
    EndCardCollectableShield: '/textures/endcard/Card_Collectable_Shield.png',
} as const

export const textureAssetCompressed = {
    Shadow_Alpha: '/textures/general/Shadow_Alpha.ktx2',
    Track_Region_1: '/textures/general/track-region-1.ktx2',
    Track_Region_2: '/textures/general/track-region-2.ktx2',
    Track_Region_3: '/textures/general/track-region-3.ktx2',
    Track_Region_4: '/textures/general/track-region-4.ktx2',
    Track_Transition: '/textures/general/track-transition.ktx2',
    tunnel: '/textures/general/tunnel_stele.ktx2',

    Tongue: '/textures/character/Tongue_Color.ktx2',
    Eyes_Color: '/textures/character/Eyes_Color.ktx2',
    Chameleon_Color_01: '/textures/character/Chameleon_Color_01.ktx2',
    Chameleon_Color_02: '/textures/character/Chameleon_Color_02.ktx2',
    Chameleon_Color_03: '/textures/character/Chameleon_Color_03.ktx2',
    Chameleon_Color_04: '/textures/character/Chameleon_Color_04.ktx2',
    Chameleon_Color_06: '/textures/character/Chameleon_Color_06.ktx2',
    Chameleon_Color_08: '/textures/character/Chameleon_Color_08.ktx2',

    EndCardFrame1: '/textures/endcard/Frame1.ktx2',
    EndCardFrame2Battery: '/textures/endcard/Frame2_Battery.ktx2',
    EndCardFrame2Coin: '/textures/endcard/Frame2_Coin.ktx2',
    EndCardFrame2Shield: '/textures/endcard/Frame2_Shield.ktx2',
    EndCardFrame2Stars: '/textures/endcard/Frame2_Stars.ktx2',
    EndCardFrameNormal: '/textures/endcard/Frame_N.ktx2',
    EndCardBackgroundBattery: '/textures/endcard/Card_BG_Battery.ktx2',
    EndCardBackgroundCoin: '/textures/endcard/Card_BG_Coin.ktx2',
    EndCardBackgroundShield: '/textures/endcard/Card_BG_Shield.ktx2',
    EndCardBackgroundStars: '/textures/endcard/Card_BG_Stars.ktx2',
} as const

export const hdriAsset = {
    
} as const

export const fileAsset = {
    Track_Path_Json: '/prototype/track-path.json',
} as const

export const gltfAssetUrls = assetValues(gltfAsset)
export const textureAssetUrls = assetValues(textureAsset)
export const textureAssetCompressedUrls = assetValues(textureAssetCompressed)
export const hdriAssetUrls = assetValues(hdriAsset)
export const fileAssetUrls = assetValues(fileAsset)
